


















































































































import Vue, { PropType } from "vue";
import { HealthPocMetric, HealthPocViewModel } from "@/utils/healthPocViewAdapter";
import HealthMetricCard from "./HealthMetricCard.vue";
import HealthWeeklyChart from "./HealthWeeklyChart.vue";
import HealthWorkoutCard from "./HealthWorkoutCard.vue";
import { formatDuration, metricByKey, emptyMetric, recentWorkouts, todayCards } from "../healthPagePresentation";

export default Vue.extend({
  name: "HealthDayPanel",
  components: { HealthMetricCard, HealthWeeklyChart, HealthWorkoutCard },
  props: {
    view: { type: Object as PropType<HealthPocViewModel>, required: true }
  },
  computed: {
    todayCards() {
      return todayCards(this.view);
    },
    sleepMetric(): HealthPocMetric {
      return metricByKey(this.view, "sleep") || emptyMetric("sleep", "Sono", "min");
    },
    recentWorkouts() {
      return recentWorkouts(this.view);
    }
  },
  methods: {
    formatSleepMetric(metric: HealthPocMetric): string {
      return formatDuration(metric.value);
    }
  }
});
